import Swiper from 'swiper'

export function initDestinationCarousel() {
  const carousel = document.querySelector('[data-carousel]')

  if (!carousel) return

  const stops = Array.from(carousel.querySelectorAll('[data-carousel-goto]'))

  const updateStops = (activeIndex) => {
    stops.forEach((stop, index) => {
      stop.classList.toggle('is-active', index === activeIndex)
      stop.classList.toggle('is-passed', index < activeIndex)
    })

    // when the stepper overflows (mobile), keep the active stop centered
    const activeStop = stops[activeIndex]
    const stepper = activeStop?.parentElement
    if (stepper && stepper.scrollWidth > stepper.clientWidth) {
      stepper.scrollTo({
        left: activeStop.offsetLeft - (stepper.clientWidth - activeStop.offsetWidth) / 2,
        behavior: 'smooth',
      })
    }
  }

  const prevButton = carousel.querySelector('[data-carousel-prev]')
  const nextButton = carousel.querySelector('[data-carousel-next]')

  const updateArrows = (instance) => {
    prevButton?.classList.toggle('is-disabled', instance.isBeginning)
    nextButton?.classList.toggle('is-disabled', instance.isEnd)
  }

  // snap every slide (including the last) to the left edge instead of
  // clamping the end position to keep the viewport filled
  const alignSnapToSlides = (instance) => {
    instance.snapGrid = [...instance.slidesGrid]
  }

  const swiper = new Swiper(carousel.querySelector('.swiper'), {
    slidesPerView: 1,
    spaceBetween: 32,
    speed: 800,
    grabCursor: true,
    breakpoints: {
      1024: {
        slidesPerView: 1.2,
      },
    },
    on: {
      init: alignSnapToSlides,
      update: alignSnapToSlides,
      resize: (instance) => {
        alignSnapToSlides(instance)
        instance.slideTo(instance.activeIndex, 0)
      },
      slideChange: (instance) => {
        updateStops(instance.activeIndex)
        updateArrows(instance)
      },
    },
  })

  prevButton?.addEventListener('click', () => swiper.slidePrev())
  nextButton?.addEventListener('click', () => swiper.slideNext())
  stops.forEach((stop, index) => {
    stop.addEventListener('click', () => swiper.slideToLoop(index))
  })
}
